import { render, staticRenderFns } from "./NoLayoutAppendPrependExample.vue?vue&type=template&id=78b4390a&scoped=true&"
import script from "./NoLayoutAppendPrependExample.vue?vue&type=script&lang=js&"
export * from "./NoLayoutAppendPrependExample.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78b4390a",
  null
  
)

export default component.exports